<template>
  <section class="section alt">
    <div class="container">
      <SectionHead eyebrow="ECO ROLES">
        生态角色 · 你是<span style="color:#83e6ff">哪一种</span>
      </SectionHead>
      <p class="section-copy personas-copy">
        8 种典型角色，都能在易隆创生态中找到自己的位置。
      </p>
      <div class="grid-4 persona-grid">
        <PersonaMiniCard
          v-for="(p, i) in personas"
          :key="i"
          :icon="icons[i]"
          :title="p[1]"
          :tagline="taglines[i]"
          @click="$router.push('/personas')"
        />
      </div>
      <div class="persona-cta">
        无论你是哪一种，加入生态后，<span style="color:#5cf2a8">你的贡献会变成回报</span>，你的短板由生态补齐。
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import SectionHead from '@/components/display/SectionHead.vue';
import PersonaMiniCard from '@/components/cards/PersonaMiniCard.vue';

const PERSONA_ICONS = [
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="14" y2="17"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><polyline points="9 15 11 17 15 13"/></svg>'
];

const TAGLINES = [
  '有施工能力缺业务资源',
  '想做大体量缺资质能力',
  '有人脉关系缺转化路径',
  '有产品渠道缺项目入口',
  '代理多个品牌但体量有限',
  '有项目资源缺分包资源',
  '有行业关系缺落地能力',
  '有信息资源缺服务能力'
];

export default {
  name: 'HomePersonas',
  components: { SectionHead, PersonaMiniCard },
  data() {
    return {
      icons: PERSONA_ICONS,
      taglines: TAGLINES
    };
  },
  computed: {
    ...mapState('ecosystem', ['personas'])
  }
};
</script>

<style lang="less" scoped>
.personas-copy {
  text-align: center;
  max-width: 700px;
  margin: -30px auto 40px;
}

.persona-grid {
  gap: 22px;
}

.persona-cta {
  margin: 42px auto 0;
  max-width: 1080px;
  padding: 24px 32px;
  border-radius: 22px;
  background: linear-gradient(135deg, rgba(66, 217, 255, 0.08), rgba(131, 230, 255, 0.03));
  border: 1px solid rgba(66, 217, 255, 0.22);
  text-align: center;
  font-size: 15px;
  color: #c8d4ec;
  line-height: 1.7;
}
</style>
